import React from 'react';
import css from './NotFound.scss';

export default class NotFound extends React.Component {

  render() {
    return (
      <div className={css['container']}>
        <div>404</div>
        <div>Page not found</div>
      </div>
    );
  }
}
